import type { CountryBiasLocale } from './types';

export const hy: CountryBiasLocale = {
  countries: [
    {
      id: 'ar',
      name: 'Արգենտինա',
      flag: '🇦🇷',
      region: 'Americas',
      rationale:
        'Կոլեկտիվիստական, անորոշության խուսափման բարձր մակարդակ, հուզականորեն արտահայտիչ, կարճաժամկետ կողմնորոշված',
      biases: [50, 53, 93, 79, 37, 22, 55, 91, 75, 100, 13],
      confidence: 0.74,
      aliases: ['Արգենտինացի', 'Argentine', 'Argentinian', 'Argentinean'],
      biasRationale: `Արգենտինան ունի չափավոր կոլեկտիվիստական մշակույթ (IDV 46) անորոշության խուսափման բարձր մակարդակով (86) և շատ բարձր հաճույքակենտրոնությամբ (62)։ Սա ստեղծում է մշակույթ, որտեղ խմբային համաձայնությունը և հուզական պատմությունը կառավարում են որոշումները, իսկ անորոշության խուսափումը հակում է դեպի ծանոթ տարբերակները։ Հաճույքակենտրոնության բարձր մակարդակը դրսևորվում է ակնթարթային վարձատրության նկատմամբ զգայունության և դրականության կողմ հակումների տեսքով։`,
    },
    {
      id: 'am',
      name: 'Հայաստան',
      flag: '🇦🇲',
      region: 'Middle East',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, ավանդապահպան, սփյուռքի հետ կապված, ընտանեկենտրոն',
      biases: [48, 53, 50, 88, 81, 19, 47, 90, 70, 25, 52],
      confidence: 0.67,
      aliases: ['Հայ', 'հայկական', 'Armenian', 'Hayastan'],
      biasRationale: `Հայաստանը ցուցադրում է իշխանական մեծ հեռավորություն և ուժեղ կոլեկտիվիզմ՝ արմատավորված հնագույն մշակութային ավանդույթներում և խորապես ընտանեկենտրոն սոցիալական կառուցվածքում։ Սփյուռքի փորձառությունը ուժեղացնում է ներխմբային ֆավորիտիզմը և մշակութային ժառանգության շուրջ տիրապետման էֆեկտները։ Անորոշության խուսափման բարձր մակարդակը և երկարաժամկետ կողմնորոշումը՝ ձևավորված դարավոր կայունությունից, ստեղծում են պահպանողականություն և պարտավորությունների աճ որոշումներ ընդունելիս։`,
    },
    {
      id: 'au',
      name: 'Ավստրալիա',
      flag: '🇦🇺',
      region: 'Oceania',
      rationale:
        'Անհատապաշտական, հակաավտորիտար, ռիսկային, գործնական-անպաշտոնական',
      biases: [91, 13, 44, 79, 80, 78, 55, 12, 74, 77, 71, 37],
      confidence: 0.87,
      aliases: ['Ավստրալիացի', 'Australian', 'Aussie'],
      biasRationale: `Ավստրալիան ունի շատ բարձր անհատապաշտություն (90) և հաճույքակենտրոնություն (71)՝ նկատելիորեն ցածր իշխանական հեռավորությամբ (38)։ Հակաավտորիտար «բարձր կակաչի համախտանիշի» մշակույթը սնում է ռեակտիվությունը և ատրիբուցիայի հիմնարար սխալը, իսկ բարձր հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ։ Ուժեղ անհատապաշտությունը ձևավորում է իլյուզորային գերազանցություն և գերվստահություն սեփական դատողություններում։`,
    },
    {
      id: 'at',
      name: 'Ավստրիա',
      flag: '🇦🇹',
      region: 'Europe',
      rationale:
        'Չափավոր անհատապաշտություն, անորոշության խուսափման բարձր մակարդակ, մասկուլինական-նվաճողական, կառուցվածքային',
      biases: [86, 93, 69, 44, 19, 102, 85, 87, 81, 20, 94],
      confidence: 0.8,
      aliases: ['Ավստրիացի', 'Austrian'],
      biasRationale: `Ավստրիան ունի մասկուլինության (79) և անորոշության խուսափման (70) բարձր ցուցանիշներ՝ չափավոր անհատապաշտությամբ (55)։ Նվաճողական մշակույթը՝ զուգորդված կառուցվածքի կարիքի հետ, ձևավորում է զրո-ռիսկի հակում և երկիմաստության խուսափում։ Բարձր մասկուլինությունը ստեղծում է գերվստահություն և ատրիբուցիայի հիմնարար սխալ, իսկ ավստրիական մանրակրկիտությունը ձևավորում է հենում սիստեմատիկ մշակման և տեղեկատվության որոնման վրա։`,
    },
    {
      id: 'be',
      name: 'Բելգիա',
      flag: '🇧🇪',
      region: 'Europe',
      rationale:
        'Անորոշության խուսափման բարձր մակարդակ, չափավոր անհատապաշտություն, համաձայնության ձգտող, լեզվապես բաժանված',
      biases: [93, 86, 19, 50, 70, 94, 92, 10, 58, 102, 85],
      confidence: 0.79,
      aliases: ['Բելգիացի', 'Belgian'],
      biasRationale: `Բելգիան ունի անորոշության խուսափման շատ բարձր մակարդակ (94)՝ չափավոր անհատապաշտությամբ (75) և ցածր հաճույքակենտրոնությամբ (57)։ Անորոշության խուսափման ուժեղ մակարդակը ձևավորում է երկիմաստության խուսափում և զրո-ռիսկի հակում, իսկ լեզվական համայնքների միջև համաձայնության ձգտող մշակույթը ստեղծում է զանգվածային էֆեկտներ և սոցիալական ցանկալիություն։ Զսպվածությունը նպաստում է բացթողման կողմնակալությանը և նորմալության կողմնակալությանը։`,
    },
    {
      id: 'br',
      name: 'Բրազիլիա',
      flag: '🇧🇷',
      region: 'Americas',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, հաճույքակենտրոն, հուզականորեն արտահայտիչ',
      biases: [79, 55, 50, 37, 13, 75, 100, 22, 41, 53, 48, 84],
      confidence: 0.82,
      aliases: ['Բրազիլացի', 'Brazilian', 'Brasil'],
      biasRationale: `Բրազիլիան ունի իշխանական մեծ հեռավորություն (69) և շատ բարձր հաճույքակենտրոնություն (59)՝ ուժեղ կոլեկտիվիզմով (IDV 38)։ Հաճույքակենտրոն, հուզականորեն արտահայտիչ մշակույթը ձևավորում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ, իսկ կոլեկտիվիզմը ստեղծում է զանգվածային էֆեկտներ և ներխմբային հակումներ։ Իշխանական մեծ հեռավորությունը խթանում է ավտորիտետային հակումը, իսկ վառ պատմողական ավանդույթը անեկդոտային վկայությունները հատկապես համոզիչ է դարձնում։`,
    },
    {
      id: 'ca',
      name: 'Կանադա',
      flag: '🇨🇦',
      region: 'Americas',
      rationale:
        'Անհատապաշտական, հավասարազոր, բազմամշակութային-համաձայնության ձգտող, անորոշության խուսափման չափավոր մակարդակ',
      biases: [70, 50, 77, 55, 91, 80, 22, 93, 97, 10, 13, 44],
      confidence: 0.87,
      aliases: ['Կանադացի', 'Canadian'],
      biasRationale: `Կանադան ունի անհատապաշտության բարձր մակարդակ (80)՝ ցածր իշխանական հեռավորությամբ (39) և չափավոր հաճույքակենտրոնությամբ (68)։ Բազմամշակութային համաձայնության մշակույթը ստեղծում է սոցիալական ցանկալիություն և զանգվածային էֆեկտներ՝ անհատապաշտական իլյուզորային գերազանցության հետ միասին։ Անորոշության խուսափման չափավոր մակարդակը (48)՝ զուգորդված քաղաքավարության նորմերի հետ, ստեղծում է հակում դեպի բացթողման հակում, իսկ հաճույքակենտրոնությունը ձևավորում է նորության գրավչություն և դրականության էֆեկտներ։`,
    },
    {
      id: 'cl',
      name: 'Չիլի',
      flag: '🇨🇱',
      region: 'Americas',
      rationale:
        'Չափավոր կոլեկտիվիզմ, անորոշության խուսափման բարձր մակարդակ, դասային գիտակցական, զսպված',
      biases: [93, 86, 48, 90, 19, 83, 10, 30, 50, 57, 81],
      confidence: 0.73,
      aliases: ['Չիլիացի', 'Chilean'],
      biasRationale: `Չիլին ունի անորոշության խուսափման բարձր մակարդակ (86)՝ չափավոր կոլեկտիվիզմով (IDV 23) և նկատելիորեն ցածր հաճույքակենտրոնությամբ (28)։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության և զրո-ռիսկի ուժեղ հակումներ, իսկ զսպվածությունը ձևավորում է բացթողման հակում և «ջայլամի» էֆեկտներ։ Դասային-գիտակցական սոցիալական հիերարխիաները խթանում են ավտորիտետային հակումը և համակարգի արդարացումը, իսկ կորստի-խուսափումը ուժեղանում է տնտեսական անկայունության գիտակցմամբ։`,
    },
    {
      id: 'cn',
      name: 'Չինաստան',
      flag: '🇨🇳',
      region: 'Asia',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, երկարաժամկետ ռազմավարական, դեմքը պահպանող',
      biases: [48, 81, 90, 22, 18, 57, 83, 50, 42, 104, 53, 70, 19],
      confidence: 0.88,
      aliases: ['Չինացի', 'Chinese', 'Zhongguo'],
      biasRationale: `Չինաստանը ունի շատ բարձր երկարաժամկետ կողմնորոշում (87) և իշխանական հեռավորություն (80)՝ ուժեղ կոլեկտիվիզմով (IDV 20)։ Երկարաժամկետ-ռազմավարական մշակույթը ձևավորում է պարտավորությունների աճ, կորստի-խուսափում և մտավոր հաշվապահություն։ Իշխանական մեծ հեռավորությունը ստեղծում է ավտորիտետային հակում և համակարգի արդարացում, իսկ դեմքը պահպանող կոլեկտիվիզմը ստեղծում է սոցիալական ցանկալիություն, զանգվածային էֆեկտներ և ուժեղ ներխմբային ֆավորիտիզմ։`,
    },
    {
      id: 'co',
      name: 'Կոլումբիա',
      flag: '🇨🇴',
      region: 'Americas',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, հաճույքակենտրոն, ընտանեկենտրոն, ձեռներեցական',
      biases: [48, 53, 79, 55, 37, 50, 13, 75, 22, 41, 100],
      confidence: 0.72,
      aliases: ['Կոլումբիացի', 'Colombian'],
      biasRationale: `Կոլումբիան ունի իշխանական մեծ հեռավորություն (67) և շատ բարձր հաճույքակենտրոնություն (83)՝ ուժեղ կոլեկտիվիզմով (IDV 13)։ Բարձր հաճույքակենտրոն մշակույթը ձևավորում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ, իսկ կոլեկտիվիզմը և ընտանեկենտրոնությունը ստեղծում են ներխմբային ֆավորիտիզմ և զանգվածային էֆեկտներ։ Ձեռներեցական ոգին՝ զուգորդված պատմողական ավանդույթների հետ, ստեղծում է զգայունություն «շոգ ձեռքի» սխալանքի և վառ պատմողական համոզիչության նկատմամբ։`,
    },
    {
      id: 'cz',
      name: 'Չեխիա',
      flag: '🇨🇿',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, գործնական, անորոշության խուսափման բարձր մակարդակ, զսպված, թերահավատ',
      biases: [93, 19, 91, 30, 10, 17, 86, 83, 87, 71, 25],
      confidence: 0.74,
      aliases: ['Չեխ', 'Czech', 'Czechia'],
      biasRationale: `Չեխիան ունի անհատապաշտության բարձր մակարդակ (58)՝ նկատելի անորոշության խուսափմամբ (74) և շատ ցածր հաճույքակենտրոնությամբ (29)։ Զսպված, թերահավատ մշակույթը ստեղծում է «ջայլամի» և բացթողման հակումներ՝ բացասականության կողմնակալության հետ միասին։ Անորոշության խուսափման բարձր մակարդակը ձևավորում է երկիմաստության խուսափում և պահպանողականություն, իսկ գործնական անհատապաշտությունը ստեղծում է ռեակտիվություն արտաքին ճնշման նկատմամբ և մշակման բարդության միջոցով ներգրավվածություն։`,
    },
    {
      id: 'dk',
      name: 'Դանիա',
      flag: '🇩🇰',
      region: 'Europe',
      rationale:
        'Բարձր անհատապաշտություն, հավասարազոր, ֆեմինինական մշակույթ, ցածր իշխանական հեռավորություն, հաճույքակենտրոն',
      biases: [70, 58, 97, 10, 50, 55, 80, 13, 85, 93, 44],
      confidence: 0.83,
      aliases: ['Դանիացի', 'Danish', 'Dane'],
      biasRationale: `Դանիան ունի շատ բարձր անհատապաշտություն (74)՝ ծայրահեղ ցածր իշխանական հեռավորությամբ (18) և բարձր հաճույքակենտրոնությամբ (70)։ «Janteloven» հավասարազոր մշակույթը ձևավորում է սոցիալական ցանկալիություն և նորմալության հակում՝ սահմանափակելով ինքնաառաջխաղացումը։ Ցածր մասկուլինությունը (16) ստեղծում է համաձայնության ձգտում զանգվածային էֆեկտների միջոցով, իսկ հաճույքակենտրոնությունը ստեղծում է նորության գրավչություն և դրականության հակումներ։ Ֆեմինինական մշակույթը գնահատում է «ավելի քիչ — ավելի լավ» սկզբունքով պարզությունը։`,
    },
    {
      id: 'eg',
      name: 'Եգիպտոս',
      flag: '🇪🇬',
      region: 'Middle East',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, զսպված, ավանդույթներով խարսխված, անորոշության խուսափման բարձր մակարդակ',
      biases: [48, 53, 90, 19, 47, 93, 52, 70, 88, 58, 25, 30],
      confidence: 0.72,
      aliases: ['Եգիպտացի', 'Egyptian', 'Misr'],
      biasRationale: `Եգիպտոսը ունի շատ բարձր իշխանական հեռավորություն (70)՝ ուժեղ կոլեկտիվիզմով և բարձր զսպվածությամբ։ Ավանդույթներով խարսխված մշակույթը ամուր ավտորիտար կառուցվածքով ձևավորում է ավտորիտետային հակում, համակարգի արդարացում և պահպանողականություն։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության խուսափում, իսկ կոլեկտիվիզմը ստեղծում է ներխմբային ֆավորիտիզմ և արտախմբային միատարրություն։ Զսպվածությունը դրսևորվում է «ջայլամի» էֆեկտով և սոցիալական ցանկալիությամբ։`,
    },
    {
      id: 'et',
      name: 'Եթովպիա',
      flag: '🇪🇹',
      region: 'Africa',
      rationale:
        'Կոլեկտիվիստական, համայնքային, իշխանական մեծ հեռավորություն, բանավոր ավանդույթ, հոգևոր հիմնավորված',
      biases: [48, 53, 37, 47, 50, 31, 96, 76, 19, 70, 58],
      confidence: 0.66,
      aliases: ['Եթովպիացի', 'Ethiopian'],
      biasRationale: `Եթովպիան ցուցադրում է իշխանական մեծ հեռավորություն և ուժեղ կոլեկտիվիզմ՝ արմատավորված համայնքային սոցիալական կառուցվածքներում և խորը հոգևոր ավանդույթներում։ Հարուստ բանավոր պատմողական ավանդույթը անեկդոտային վկայությունները և կոնյունկցիայի սխալանքը հատկապես ազդեցիկ է դարձնում։ Ավտորիտետային հակումը և արդարության սխալանքը ուժեղանում են կրոնական շրջանակներով, իսկ համայնքային որոշումներ ընդունելը ստեղծում է զանգվածային էֆեկտներ և ներխմբային ֆավորիտիզմ։`,
    },
    {
      id: 'fi',
      name: 'Ֆինլանդիա',
      flag: '🇫🇮',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, ցածր իշխանական հեռավորություն, անորոշության խուսափման բարձր մակարդակ, զսպված, հավասարազոր',
      biases: [93, 86, 10, 30, 70, 87, 102, 85, 17, 94, 58, 19],
      confidence: 0.83,
      aliases: ['Ֆին', 'Finnish', 'Finn', 'Suomi'],
      biasRationale: `Ֆինլանդիան ունի անհատապաշտության բարձր մակարդակ (63)՝ շատ ցածր իշխանական հեռավորությամբ (33), անորոշության խուսափման բարձր մակարդակով (59) և նկատելիորեն ցածր հաճույքակենտրոնությամբ (57)։ Զսպված «sisu» մշակույթը ձևավորում է բացթողման հակումներ և «ջայլամի» էֆեկտներ, իսկ անորոշության խուսափումը ստեղծում է երկիմաստության խուսափում և զրո-ռիսկի հակում։ Ֆինների մեթոդիկ մոտեցումը ստեղծում է ներգրավվածություն մշակման բարդության միջոցով և հաջորդական հիշողության նախընտրություններ, իսկ սոցիալական ցանկալիությունը արտացոլում է զսպված հաղորդակցության ոճը։`,
    },
    {
      id: 'fr',
      name: 'Ֆրանսիա',
      flag: '🇫🇷',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, սակայն հիերարխիկ, գեղագիտությամբ առաջնորդվող, ինտելեկտուալ-հակասական',
      biases: [54, 20, 91, 89, 92, 97, 104, 71, 14, 83, 69, 87],
      confidence: 0.88,
      aliases: ['Ֆրանսիացի', 'French'],
      biasRationale: `Ֆրանսիան ունի անհատապաշտության բարձր մակարդակ (71)՝ նկատելի իշխանական հեռավորությամբ (68) և անորոշության խուսափման բարձր մակարդակով (86)։ Գեղագիտությամբ առաջնորդվող մշակույթը ուժեղացնում է լուսապսակի և կոնտրաստի էֆեկտները, իսկ ինտելեկտուալ հակասությունը սնում է ռեակտիվությունը և հակառակ արձագանքի էֆեկտները։ Անորոշության խուսափման բարձր մակարդակը՝ զուգորդված անհատապաշտության հետ, ստեղծում է եզակի պրոֆիլ, որտեղ գերվստահությունը հանդիպում է կորստի-խուսափմանը, և ինտելեկտուալ խստության շեշտադրումը ձևավորում է ներգրավվածություն մշակման բարդության միջոցով։`,
    },
    {
      id: 'de',
      name: 'Գերմանիա',
      flag: '🇩🇪',
      region: 'Europe',
      rationale:
        'Կանոնակենտրոն, ինժեներական մտածողություն, ճշգրտությամբ առաջնորդվող, չափավոր անհատապաշտություն',
      biases: [87, 94, 86, 19, 25, 49, 102, 85, 81, 93, 83, 17],
      confidence: 0.89,
      aliases: ['Գերմանացի', 'German', 'Deutsche'],
      biasRationale: `Գերմանիան ունի անհատապաշտության բարձր մակարդակ (67)՝ անորոշության խուսափման ուժեղ մակարդակով (65) և երկարաժամկետ կողմնորոշման բարձր մակարդակով (83)։ Ինժեներա-ճշգրտության մշակույթը ձևավորում է ներգրավվածություն մշակման բարդության միջոցով, տեղեկատվական հակում և հաջորդական հիշողության նախընտրություններ։ Անորոշության խուսափումը ստեղծում է զրո-ռիսկի և երկիմաստության հակումներ, իսկ երկարաժամկետ կողմնորոշումը ուժեղացնում է պարտավորությունների աճը և կորստի-խուսափումը։ Կանոնակենտրոն մտածողությունը ստեղծում է պահպանողականություն և հաստատման հակում։`,
    },
    {
      id: 'gr',
      name: 'Հունաստան',
      flag: '🇬🇷',
      region: 'Europe',
      rationale:
        'Կոլեկտիվիզմին հակվող, շատ բարձր անորոշության խուսափում, իշխանական մեծ հեռավորություն, հաճույքակենտրոն',
      biases: [93, 86, 48, 53, 79, 55, 91, 88, 19, 37, 100, 81],
      confidence: 0.75,
      aliases: ['Հույն', 'Greek', 'Hellenic', 'Hellas'],
      biasRationale: `Հունաստանը ունի Եվրոպայում անորոշության խուսափման ամենաբարձր մակարդակը (100)՝ բարձր իշխանական հեռավորությամբ (60) և չափավոր կոլեկտիվիզմով (IDV 35)։ Անորոշության խուսափման ծայրահեղ մակարդակը ձևավորում է երկիմաստության և զրո-ռիսկի հակումներ, իսկ հաճույքակենտրոն միջերկրածովյան մշակույթը (IVR 50) ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ։ Ուժեղ ընտանեկան կոլեկտիվիզմը ստեղծում է ներխմբային ֆավորիտիզմ, իսկ ճարտասանական ավանդույթը ուժեղացնում է անեկդոտային վկայությունների համոզիչությունը։`,
    },
    {
      id: 'in',
      name: 'Հնդկաստան',
      flag: '🇮🇳',
      region: 'Asia',
      rationale:
        'Հիերարխիկ, կոլեկտիվիստական, երկարաժամկետ կողմնորոշված, սակարկության մշակույթ',
      biases: [48, 53, 25, 81, 47, 96, 57, 18, 36, 42, 50, 88, 90],
      confidence: 0.85,
      aliases: ['Հնդիկ', 'Indian', 'Bharat'],
      biasRationale: `Հնդկաստանը ունի շատ բարձր իշխանական հեռավորություն (77)՝ ուժեղ երկարաժամկետ կողմնորոշմամբ (51) և չափավոր կոլեկտիվիզմով (IDV 48)։ Հիերարխիկ մշակույթը ձևավորում է ավտորիտետային հակում և համակարգի արդարացում, իսկ սակարկության ավանդույթը ուժեղացնում է խարսխման էֆեկտները և մտավոր հաշվապահությունը։ Երկարաժամկետ կողմնորոշումը ստեղծում է պարտավորությունների աճ, իսկ պատմողական ավանդույթը կոնյունկցիայի սխալանքը և անեկդոտային պատումները չափազանց համոզիչ է դարձնում։`,
    },
    {
      id: 'id',
      name: 'Ինդոնեզիա',
      flag: '🇮🇩',
      region: 'Asia',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, ներդաշնակություն փնտրող, հոգևոր հիմնավորված',
      biases: [48, 50, 70, 58, 10, 30, 47, 90, 53, 31, 19, 42],
      confidence: 0.78,
      aliases: ['Ինդոնեզացի', 'Indonesian'],
      biasRationale: `Ինդոնեզիան ունի շատ բարձր իշխանական հեռավորություն (78)՝ ուժեղ կոլեկտիվիզմով (IDV 14) և ցածր հաճույքակենտրոնությամբ (38)։ Ներդաշնակություն փնտրող «musyawarah» մշակույթը ձևավորում է սոցիալական ցանկալիություն, բացթողման հակում և նորմալության հակում։ Իշխանական մեծ հեռավորությունը ստեղծում է ավտորիտետային հակում և համակարգի արդարացում, իսկ հոգևոր հիմքը ուժեղացնում է արդարության սխալանքը և սուբյեկտիվ հաստատումը։ Զսպվածությունը դրսևորվում է որպես առճակատման խուսափում «ջայլամի» էֆեկտի միջոցով։`,
    },
    {
      id: 'ir',
      name: 'Իրան',
      flag: '🇮🇷',
      region: 'Middle East',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, անորոշության խուսափման բարձր մակարդակ, զսպված, ավանդապահպան',
      biases: [48, 90, 19, 93, 53, 52, 88, 47, 30, 10, 70, 89],
      confidence: 0.68,
      aliases: ['Իրանցի', 'Պարսիկ', 'Iranian', 'Persian'],
      biasRationale: `Իրանը ունի շատ բարձր իշխանական հեռավորություն և անորոշության խուսափում՝ ուժեղ կոլեկտիվիզմով և զսպվածությամբ։ Ավանդապահպան մշակույթը ձևավորում է պահպանողականություն, համակարգի արդարացում և ավտորիտետային հակում։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության խուսափում, իսկ կոլեկտիվիզմը ուժեղացնում է ներխմբային ֆավորիտիզմը և արտախմբային միատարրությունը։ Զսպվածությունը և մշակութային դիմացկունությունը ստեղծում են «ջայլամի» և բացթողման հակումներ, իսկ հակառակ արձագանքի էֆեկտները արտացոլում են արտաքին պատումներին դիմադրությունը։`,
    },
    {
      id: 'ie',
      name: 'Իռլանդիա',
      flag: '🇮🇪',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, ցածր իշխանական հեռավորություն, մասկուլինական, կարճաժամկետ կողմնորոշված, շատ հաճույքակենտրոն',
      biases: [13, 37, 79, 55, 80, 91, 44, 77, 12, 100, 75],
      confidence: 0.76,
      aliases: ['Իռլանդացի', 'Irish', 'Eire'],
      biasRationale: `Իռլանդիան ունի անհատապաշտության բարձր մակարդակ (70)՝ ցածր իշխանական հեռավորությամբ (28) և շատ բարձր հաճույքակենտրոնությամբ (65)։ Պատմողական մշակույթը անեկդոտային վկայությունները և հումորի էֆեկտները հատկապես հզոր է դարձնում։ Բարձր հաճույքակենտրոնությունը ձևավորում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ, իսկ անհատապաշտությունը ստեղծում է իլյուզորային գերազանցություն և ռեակտիվություն։ Կարճաժամկետ կողմնորոշումը (LTO 24) ստեղծում է նորության գրավչություն, իսկ ընկերակցական մշակույթը ուժեղացնում է տարօրինակության և Բարնումի էֆեկտները։`,
    },
    {
      id: 'il',
      name: 'Իսրայել',
      flag: '🇮🇱',
      region: 'Middle East',
      rationale:
        'Ուղիղ հաղորդակցություն, ստարտափ-մշակույթ, անվտանգությանը կարևորող, ցածր իշխանական հեռավորություն',
      biases: [69, 91, 89, 74, 80, 83, 1, 36, 79, 84, 78, 77],
      confidence: 0.84,
      aliases: ['Իսրայելցի', 'Israeli'],
      biasRationale: `Իսրայելը ունի ցածր իշխանական հեռավորություն (13)՝ բարձր անհատապաշտությամբ (54) և անորոշության խուսափման չափավոր մակարդակով (81)։ «Chutzpah» ստարտափ-մշակույթը ձևավորում է գերվստահություն, Դանինգ-Կրյուգերի էֆեկտ և իլյուզորային գերազանցություն, իսկ ուղիղ հաղորդակցության ոճը ստեղծում է ռեակտիվություն և հակառակ արձագանքի էֆեկտներ։ Անվտանգության մտահոգությունը ուժեղացնում է մատչելիության էվրիստիկաները և հավանականության անտեսումը, իսկ նորարարական տնտեսությունը ստեղծում է նորության գրավչություն և IKEA-ի էֆեկտ։`,
    },
    {
      id: 'it',
      name: 'Իտալիա',
      flag: '🇮🇹',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, անորոշության խուսափման բարձր մակարդակ, մասկուլինական, գեղագիտությամբ առաջնորդվող, ընտանեկենտրոն',
      biases: [54, 93, 86, 20, 53, 69, 14, 92, 104, 83, 88, 79],
      confidence: 0.84,
      aliases: ['Իտալացի', 'Italian'],
      biasRationale: `Իտալիան ունի անհատապաշտության բարձր մակարդակ (76), մասկուլինություն (70) և անորոշության խուսափում (75)։ Գեղագիտությանը կենտրոնացած մշակույթը ուժեղացնում է լուսապսակի և պատկերի գերազանցության էֆեկտները, իսկ անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության և զրո-ռիսկի հակումներ։ Մասկուլինությունը ձևավորում է գերվստահություն և մրցակցային շրջանակում կոնտրաստի և խայծի էֆեկտների միջոցով։ Ընտանեկան կոլեկտիվիզմը տեղական մակարդակում ստեղծում է ներխմբային ֆավորիտիզմ, իսկ կորստի-խուսափումը և տիրապետման էֆեկտը ուժեղանում են ժառանգության պահպանման արժեքներով։`,
    },
    {
      id: 'jp',
      name: 'Ճապոնիա',
      flag: '🇯🇵',
      region: 'Asia',
      rationale:
        'Կոլեկտիվիստական, ծայրահեղ բարձր անորոշության խուսափում, հիերարխիկ, մանրակրկիտ-պերֆեկցիոնիստական',
      biases: [50, 90, 19, 48, 70, 93, 86, 101, 54, 102, 81, 83, 10],
      confidence: 0.9,
      aliases: ['Ճապոնացի', 'Japanese', 'Nippon'],
      biasRationale: `Ճապոնիան ունի ծայրահեղ բարձր անորոշության խուսափում (92) և երկարաժամկետ կողմնորոշում (88)՝ ուժեղ մասկուլինությամբ (95) և կոլեկտիվիզմով (IDV 46)։ Պերֆեկցիոնիստական մշակույթը ձևավորում է զրո-ռիսկի հակում, երկիմաստության խուսափում և մանրակրկիտ մշակում հաջորդական հիշողության միջոցով։ Բարձր կոլեկտիվիզմը ստեղծում է զանգվածային էֆեկտներ և սոցիալական ցանկալիություն, իսկ երկարաժամկետ կողմնորոշումը ուժեղացնում է պարտավորությունների աճը և կորստի-խուսափումը։ Հիերարխիկ կառուցվածքը ստեղծում է ավտորիտետային հակում և համակարգի արդարացում։`,
    },
    {
      id: 'ke',
      name: 'Քենիա',
      flag: '🇰🇪',
      region: 'Africa',
      rationale:
        'Համայնքակենտրոն, բջջային-կողմնորոշված տնտեսություն, հնարամիտ, բանավոր պատմողական ավանդույթ',
      biases: [37, 53, 79, 41, 76, 40, 84, 96, 69, 55, 48, 50],
      confidence: 0.73,
      aliases: ['Քենիացի', 'Kenyan'],
      biasRationale: `Քենիան ցուցադրում է չափավոր կոլեկտիվիզմ՝ ձեռներեցական դինամիզմով և բջջային-առաջնային թվային տնտեսությամբ։ Բանավոր պատմողական ավանդույթը անեկդոտային վկայությունները և կոնյունկցիայի սխալանքը չափազանց համոզիչ է դարձնում։ Համայնքակենտրոն որոշումներ ընդունելը ստեղծում է ներխմբային ֆավորիտիզմ և զանգվածային էֆեկտներ, իսկ հնարամիտ ձեռներեցական մշակույթը ձևավորում է վերահսկողության պատրանք, գերվստահություն և ինքնակառուցված լուծումներից IKEA-ի էֆեկտներ։`,
    },
    {
      id: 'my',
      name: 'Մալայզիա',
      flag: '🇲🇾',
      region: 'Asia',
      rationale:
        'Շատ բարձր իշխանական հեռավորություն, կոլեկտիվիստական, անորոշության խուսափման չափավոր մակարդակ, ներդաշնակություն փնտրող',
      biases: [48, 50, 53, 90, 70, 58, 10, 47, 22, 88, 19],
      confidence: 0.75,
      aliases: ['Մալայզիացի', 'Malaysian'],
      biasRationale: `Մալայզիան ունի աշխարհի ամենաբարձր իշխանական հեռավորությունը (100)՝ ուժեղ կոլեկտիվիզմով (IDV 26) և անորոշության խուսափման չափավոր մակարդակով (36)։ Իշխանական ծայրահեղ մեծ հեռավորությունը ձևավորում է ավտորիտետային հակում և համակարգի արդարացում, իսկ ներդաշնակություն փնտրող կոլեկտիվիզմը ստեղծում է զանգվածային էֆեկտներ, ներխմբային ֆավորիտիզմ և սոցիալական ցանկալիություն։ «Դեմքի պահպանման» մշակույթը ուժեղացնում է բացթողման հակումը և նորմալության հակումը, իսկ շրջանակման էֆեկտները ուժեղանում են բազմազգ համաձայնության ավանդույթով։`,
    },
    {
      id: 'mx',
      name: 'Մեքսիկա',
      flag: '🇲🇽',
      region: 'Americas',
      rationale:
        'Կոլեկտիվիստական, ընտանեկենտրոն, իշխանական մեծ հեռավորություն, արտահայտիչ-հաճույքակենտրոն',
      biases: [53, 48, 79, 37, 100, 7, 55, 75, 22, 84, 50, 41],
      confidence: 0.82,
      aliases: ['Մեքսիկացի', 'Mexican'],
      biasRationale: `Մեքսիկան ունի իշխանական մեծ հեռավորություն (81)՝ ուժեղ կոլեկտիվիզմով (IDV 30) և շատ բարձր հաճույքակենտրոնությամբ (97)։ Ընտանեկենտրոն մշակույթը ձևավորում է ներխմբային ֆավորիտիզմ և ավտորիտետային հակում, իսկ ծայրահեղ հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ։ Հուզականորեն արտահայտիչ մշակույթը ուժեղացնում է տրամադրությանը-համահունչ հիշողությունը և մարող աֆեկտի հակումը, իսկ անեկդոտային պատմողականությունը և Բարնումի էֆեկտի զգայունությունը արտացոլում են ջերմ միջանձնային ավանդույթը։`,
    },
    {
      id: 'ma',
      name: 'Մարոկկո',
      flag: '🇲🇦',
      region: 'Africa',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, անորոշության խուսափման բարձր մակարդակ, զսպված, ավանդապաշտ',
      biases: [48, 53, 93, 19, 90, 47, 70, 52, 88, 10, 30, 18],
      confidence: 0.67,
      aliases: ['Մարոկկացի', 'Moroccan', 'Maghreb'],
      biasRationale: `Մարոկկոն ունի իշխանական մեծ հեռավորություն (70)՝ ուժեղ կոլեկտիվիզմով (IDV 25) և անորոշության խուսափման բարձր մակարդակով (68)։ Ավանդապաշտ մշակույթը ձևավորում է պահպանողականություն, ավտորիտետային հակում և համակարգի արդարացում։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության խուսափում, իսկ կոլեկտիվիզմը ուժեղացնում է ներխմբային ֆավորիտիզմը և արտախմբային միատարրությունը։ Բազարային ազդեցության բանակցային մշակույթը ուժեղացնում է խարսխման էֆեկտները, իսկ զսպվածությունը դրսևորվում է բացթողման և «ջայլամի» էֆեկտներով։`,
    },
    {
      id: 'nl',
      name: 'Նիդերլանդներ',
      flag: '🇳🇱',
      region: 'Europe',
      rationale:
        'Բարձր անհատապաշտություն, հավասարազոր, ուղիղ հաղորդակցողներ, ցածր իշխանական հեռավորություն, հաճույքակենտրոն',
      biases: [77, 91, 44, 80, 79, 55, 94, 87, 71, 97, 74, 13],
      confidence: 0.87,
      aliases: ['Հոլանդացի', 'Dutch', 'Holland'],
      biasRationale: `Նիդերլանդները ունեն շատ բարձր անհատապաշտություն (80)՝ շատ ցածր իշխանական հեռավորությամբ (38) և բարձր հաճույքակենտրոնությամբ (68)։ Ուղիղ, հավասարազոր «poldermodel» մշակույթը ձևավորում է իլյուզորային գերազանցություն, ռեակտիվություն և ատրիբուցիայի հիմնարար սխալ։ Բարձր հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ, իսկ վերլուծական առևտրային ավանդույթը ստեղծում է տեղեկատվական հակում և մշակման բարդության միջոցով ներգրավվածություն։ Հոլանդական ուղղամիտությունը ուժեղացնում է երրորդ անձի էֆեկտը և Դանինգ-Կրյուգերի հակումները։`,
    },
    {
      id: 'nz',
      name: 'Նոր Զելանդիա',
      flag: '🇳🇿',
      region: 'Oceania',
      rationale:
        'Անհատապաշտական, հավասարազոր, հակա-ձևացնող, գործնական, շատ հաճույքակենտրոն',
      biases: [91, 44, 77, 13, 55, 80, 79, 70, 12, 97, 58, 74],
      confidence: 0.82,
      aliases: ['Նորզելանդացի', 'Kiwi', 'Aotearoa'],
      biasRationale: `Նոր Զելանդիան ունի անհատապաշտության բարձր մակարդակ (79)՝ ցածր իշխանական հեռավորությամբ (22) և բարձր հաճույքակենտրոնությամբ (75)։ «Բարձր կակաչի» հակա-ձևացնող մշակույթը ստեղծում է ռեակտիվություն և սոցիալական ցանկալիություն, իսկ հավասարազորությունը ձևավորում է ատրիբուցիայի հիմնարար սխալ։ Բարձր հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ։ Քիվիների գործնական մշակույթը գնահատում է հումորի էֆեկտները և «ավելի քիչ — ավելի լավ» սկզբունքով պարզությունը, իսկ նորմալության հակումը արտացոլում է հանգիստ ապրելակերպի կողմնորոշումը։`,
    },
    {
      id: 'ng',
      name: 'Նիգերիա',
      flag: '🇳🇬',
      region: 'Africa',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, ձեռներեցական, հավատքակենտրոն',
      biases: [48, 47, 31, 37, 40, 75, 69, 79, 78, 53, 41, 76],
      confidence: 0.73,
      aliases: ['Նիգերիացի', 'Nigerian', 'Naija'],
      biasRationale: `Նիգերիան ունի իշխանական մեծ հեռավորություն (80)՝ ուժեղ կոլեկտիվիզմով (IDV 30) և չափավոր հաճույքակենտրոնությամբ (84)։ Հավատքակենտրոն մշակույթը ուժեղացնում է արդարության սխալանքը և սուբյեկտիվ հաստատումը, իսկ ձեռներեցական «hustle» մշակույթը ձևավորում է գերվստահություն, ռիսկի փոխհատուցում և վերահսկողության պատրանք։ Բարձր հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում, իսկ բանավոր ավանդույթը անեկդոտային վկայությունները և Բարնումի էֆեկտները չափազանց համոզիչ է դարձնում։`,
    },
    {
      id: 'no',
      name: 'Նորվեգիա',
      flag: '🇳🇴',
      region: 'Europe',
      rationale:
        'Բարձր անհատապաշտություն, շատ ցածր իշխանական հեռավորություն, ֆեմինինական, հաճույքակենտրոն, հավասարազոր',
      biases: [70, 58, 10, 97, 55, 80, 50, 93, 44, 13, 85],
      confidence: 0.84,
      aliases: ['Նորվեգացի', 'Norwegian'],
      biasRationale: `Նորվեգիան ունի անհատապաշտության բարձր մակարդակ (69)՝ ծայրահեղ ցածր իշխանական հեռավորությամբ (31) և շատ ցածր մասկուլինությամբ (8)։ Խորապես հավասարազոր «Janteloven» մշակույթը ձևավորում է սոցիալական ցանկալիություն և նորմալության հակում՝ ճնշելով ինքնաառաջխաղացումը։ Ցածր մասկուլինությունը ստեղծում է համաձայնության ձգտում զանգվածային էֆեկտների միջոցով և «ավելի քիչ — ավելի լավ» նախընտրություններ։ Բարձր հաճույքակենտրոնությունը (55) ստեղծում է դրականության էֆեկտներ և նորության գրավչություն, իսկ կառուցվածքային հասարակությունը ստեղծում է բացթողման հակում որոշումներ ընդունելիս։`,
    },
    {
      id: 'pk',
      name: 'Պակիստան',
      flag: '🇵🇰',
      region: 'Asia',
      rationale:
        'Շատ բարձր իշխանական հեռավորություն, կոլեկտիվիստական, զսպված, ավանդապաշտ, մասկուլինական',
      biases: [48, 53, 47, 90, 50, 19, 52, 70, 30, 10, 88, 43],
      confidence: 0.72,
      aliases: ['Պակիստանցի', 'Pakistani'],
      biasRationale: `Պակիստանը ունի շատ բարձր իշխանական հեռավորություն (55) և կոլեկտիվիզմ (IDV 14)՝ բարձր մասկուլինությամբ (50) և ծայրահեղ ցածր հաճույքակենտրոնությամբ (0)։ Ավանդապաշտ մշակույթը ամուր ավտորիտար կառուցվածքով ձևավորում է ավտորիտետային հակում, համակարգի արդարացում և պահպանողականություն։ Ծայրահեղ զսպվածությունը ստեղծում է «ջայլամի» և բացթողման հակումներ, իսկ կոլեկտիվիզմը ստեղծում է ներխմբային ֆավորիտիզմ, զանգվածային էֆեկտներ և արտախմբային միատարրություն։ Արդարության սխալանքը ուժեղանում է կրոնական և սոցիալական շրջանակներով։`,
    },
    {
      id: 'pe',
      name: 'Պերու',
      flag: '🇵🇪',
      region: 'Americas',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, անորոշության խուսափման չափավոր մակարդակ, զսպված',
      biases: [48, 53, 50, 19, 90, 10, 30, 47, 79, 37, 88],
      confidence: 0.68,
      aliases: ['Պերուացի', 'Peruvian'],
      biasRationale: `Պերուն ունի իշխանական մեծ հեռավորություն (64)՝ ուժեղ կոլեկտիվիզմով (IDV 16) և անորոշության խուսափման չափավոր մակարդակով (87)։ Հիերարխիկ մշակույթը ձևավորում է ավտորիտետային հակում և համակարգի արդարացում, իսկ կոլեկտիվիզմը ստեղծում է ներխմբային ֆավորիտիզմ և զանգվածային էֆեկտներ։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է պահպանողականություն, իսկ զսպվածությունը (IVR 46) դրսևորվում է բացթողման և «ջայլամի» էֆեկտներով։ Անեկդոտային պատմողական ավանդույթները մնում են ազդեցիկ որոշումներ ընդունելիս։`,
    },
    {
      id: 'ph',
      name: 'Ֆիլիպիններ',
      flag: '🇵🇭',
      region: 'Asia',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, շատ բարձր հաճույքակենտրոնություն, ընտանեկենտրոն',
      biases: [48, 53, 79, 55, 50, 13, 37, 75, 100, 47, 70, 41],
      confidence: 0.74,
      aliases: ['Ֆիլիպինցի', 'Filipino', 'Filipina', 'Pinoy'],
      biasRationale: `Ֆիլիպինները ունեն իշխանական մեծ հեռավորություն (94)՝ ուժեղ կոլեկտիվիզմով (IDV 32) և շատ բարձր հաճույքակենտրոնությամբ (42)։ Համայնքային «bayanihan» մշակույթը ձևավորում է ներխմբային ֆավորիտիզմ և զանգվածային էֆեկտներ, իսկ ավտորիտետի հանդեպ հարգանքը ստեղծում է ավտորիտետային հակում։ Բարձր հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ։ Ջերմ, հումորակենտրոն մշակույթը ուժեղացնում է հումորի էֆեկտները և Բարնումի զգայունությունը, իսկ մարող աֆեկտի հակումը արտացոլում է կայուն «bahala na» վերաբերմունքը։`,
    },
    {
      id: 'pl',
      name: 'Լեհաստան',
      flag: '🇵🇱',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, անորոշության խուսափման բարձր մակարդակ, մասկուլինական, զսպված, գործնական',
      biases: [93, 86, 19, 69, 44, 83, 81, 10, 30, 17, 25, 87],
      confidence: 0.8,
      aliases: ['Լեհ', 'Polish', 'Pole'],
      biasRationale: `Լեհաստանը ունի անհատապաշտության բարձր մակարդակ (60)՝ շատ բարձր անորոշության խուսափմամբ (93) և ցածր հաճույքակենտրոնությամբ (29)։ Անորոշության խուսափման ուժեղ մակարդակը ձևավորում է երկիմաստության և զրո-ռիսկի հակումներ, իսկ զսպվածությունը ստեղծում է բացթողման հակում և «ջայլամի» էֆեկտներ։ Բարձր մասկուլինությունը (64) ստեղծում է գերվստահություն և ատրիբուցիայի հիմնարար սխալ։ Երկարաժամկետ կողմնորոշումը (38)՝ զուգորդված պատմական զգուշավորության հետ, ստեղծում է կորստի-խուսափում, պարտավորությունների աճ և բացասականության հակում։`,
    },
    {
      id: 'pt',
      name: 'Պորտուգալիա',
      flag: '🇵🇹',
      region: 'Europe',
      rationale:
        'Կոլեկտիվիզմին հակվող, շատ բարձր անորոշության խուսափում, ֆեմինինական, զսպված',
      biases: [93, 86, 70, 10, 58, 50, 19, 83, 30, 100, 55, 85],
      confidence: 0.76,
      aliases: ['Պորտուգալացի', 'Portuguese'],
      biasRationale: `Պորտուգալիան ունի Եվրոպայում անորոշության խուսափման ամենաբարձր մակարդակը (99)՝ չափավոր կոլեկտիվիզմով (IDV 27) և ցածր մասկուլինությամբ (31)։ Ծայրահեղ անորոշության խուսափումը ձևավորում է երկիմաստության և զրո-ռիսկի հակումներ, իսկ մշակութային մելամաղձոտ «saudade»-ը ստեղծում է մարող աֆեկտի հակում և սոցիալական ցանկալիություն։ Ցածր մասկուլինությունը ստեղծում է նորմալության հակում և համաձայնության ձգտող զանգվածային էֆեկտներ։ Զսպվածությունը (IVR 33) դրսևորվում է բացթողման և «ջայլամի» հակումներով, իսկ կորստի-խուսափումը ուժեղանում է զգույշ ֆինանսական մշակույթով։`,
    },
    {
      id: 'ro',
      name: 'Ռումինիա',
      flag: '🇷🇴',
      region: 'Europe',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիզմին հակվող, անորոշության խուսափման բարձր մակարդակ, զսպված',
      biases: [48, 93, 90, 19, 10, 30, 83, 52, 53, 70, 17],
      confidence: 0.72,
      aliases: ['Ռումինացի', 'Romanian'],
      biasRationale: `Ռումինիան ունի իշխանական մեծ հեռավորություն (90)՝ բարձր անորոշության խուսափմամբ (90) և ցածր հաճույքակենտրոնությամբ (20)։ Ուժեղ հիերարխիայի և անորոշության խուսափման զուգակցումը ձևավորում է ավտորիտետային հակում, համակարգի արդարացում և երկիմաստության խուսափում։ Ծայրահեղ զսպվածությունը ստեղծում է բացթողման և «ջայլամի» հակումներ, իսկ կոլեկտիվիստական հակումները ստեղծում են ներխմբային ֆավորիտիզմ և արտախմբային միատարրություն։ Պատմական թերահավատությունը ուժեղացնում է պահպանողականությունը, բացասականության հակումը և կորստի-խուսափումը։`,
    },
    {
      id: 'sa',
      name: 'Սաուդյան Արաբիա',
      flag: '🇸🇦',
      region: 'Middle East',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, ավանդապահպան, զսպված',
      biases: [48, 90, 19, 52, 43, 88, 47, 89, 53, 58, 70, 86],
      confidence: 0.82,
      aliases: ['Սաուդացի', 'Saudi', 'KSA'],
      biasRationale: `Սաուդյան Արաբիան ունի շատ բարձր իշխանական հեռավորություն (95)՝ ուժեղ կոլեկտիվիզմով և անորոշության խուսափման բարձր մակարդակով (80)։ Ավանդապահպան մշակույթը ձևավորում է պահպանողականություն, համակարգի արդարացում և ավտորիտետային հակում։ Կոլեկտիվիզմը ստեղծում է ներխմբային ֆավորիտիզմ, արտախմբային միատարրություն և խմբային ատրիբուցիայի սխալներ։ Զսպված մշակույթը ստեղծում է տիրապետման էֆեկտներ ավանդույթի շուրջ և նորմալության հակում, իսկ հակառակ արձագանքի էֆեկտները արտացոլում են արագ մշակութային փոփոխությունների պատումներին դիմադրությունը։`,
    },
    {
      id: 'sg',
      name: 'Սինգապուր',
      flag: '🇸🇬',
      region: 'Asia',
      rationale:
        'Ցածր անհատապաշտություն, շատ բարձր իշխանական հեռավորություն, գործնական, զսպված, արժանավորության սկզբունքով',
      biases: [48, 90, 49, 102, 85, 81, 83, 57, 86, 70, 50, 19, 93],
      confidence: 0.85,
      aliases: ['Սինգապուրցի', 'Singaporean'],
      biasRationale: `Սինգապուրը ունի շատ բարձր իշխանական հեռավորություն (74)՝ ցածր անհատապաշտությամբ (20) և շատ բարձր երկարաժամկետ կողմնորոշմամբ (72)։ Գործնական արժանավորության մշակույթը ձևավորում է ավտորիտետային հակում, համակարգի արդարացում և ավտոմատացման հակում տեխնոլոգիապես առաջադեմ կառավարման շնորհիվ։ Երկարաժամկետ կողմնորոշումը ստեղծում է պարտավորությունների աճ, կորստի-խուսափում և մտավոր հաշվապահություն։ Ցածր հաճույքակենտրոնությունը (46) ստեղծում է զրո-ռիսկի հակում և սոցիալական ցանկալիություն, իսկ սիստեմատիկ հասարակությունը ուժեղացնում է հաջորդական հիշողությունը և միավոր հակումը։`,
    },
    {
      id: 'za',
      name: 'Հարավային Աֆրիկա',
      flag: '🇿🇦',
      region: 'Africa',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, մասկուլինական, կարճաժամկետ կողմնորոշված, զսպված',
      biases: [48, 53, 52, 69, 44, 47, 79, 78, 37, 43, 91, 83],
      confidence: 0.74,
      aliases: ['Հարավաֆրիկացի', 'Mzansi'],
      biasRationale: `Հարավային Աֆրիկան ունի իշխանական մեծ հեռավորություն (49)՝ չափավոր անհատապաշտությամբ (65) և բարձր մասկուլինությամբ (63)։ Բարդ բազմամշակութային հասարակությունը ստեղծում է ներխմբային ֆավորիտիզմ, արտախմբային միատարրություն և խմբային ատրիբուցիայի սխալներ։ Մասկուլինությունը ձևավորում է գերվստահություն և ատրիբուցիայի հիմնարար սխալ, իսկ կարճաժամկետ կողմնորոշումը (34) ստեղծում է հիպերբոլիկ զեղչում։ Ձեռներեցական դիմացկունության մշակույթը ուժեղացնում է ռիսկի փոխհատուցումը, իսկ անեկդոտային պատմողական ավանդույթները մնում են հզոր։ Ռեակտիվությունը արտացոլում է հետգաղութային դիմադրության օրինաչափությունները։`,
    },
    {
      id: 'kr',
      name: 'Հարավային Կորեա',
      flag: '🇰🇷',
      region: 'Asia',
      rationale:
        'Կոլեկտիվիստական, արտաքին տեսքին ուշադիր, տեխնոլոգիապես առաջադեմ, կոնֆուցիական հիերարխիա',
      biases: [50, 54, 64, 80, 20, 70, 15, 77, 90, 84, 81, 83, 48],
      confidence: 0.88,
      aliases: ['Կորեացի', 'Korean'],
      biasRationale: `Հարավային Կորեան ունի երկարաժամկետ կողմնորոշման բարձր մակարդակ (100) և անորոշության խուսափում (85)՝ ուժեղ կոլեկտիվիզմով (IDV 18)։ Արտաքին տեսքին ուշադիր «nunchi» մշակույթը ուժեղացնում է ուշադրության կենտրոնի էֆեկտը, լուսապսակի էֆեկտը և սոցիալական ցանկալիությունը։ Կոնֆուցիական հիերարխիան ստեղծում է ավտորիտետային հակում և համակարգի արդարացում, իսկ երկարաժամկետ կողմնորոշումը ձևավորում է պարտավորությունների աճ և կորստի-խուսափում։ Տեխնոլոգիապես առաջադեմ K-մշակույթը ստեղծում է ուժեղ նորության գրավչություն և մասնակցային ֆան-մշակույթից IKEA-ի էֆեկտներ։`,
    },
    {
      id: 'es',
      name: 'Իսպանիա',
      flag: '🇪🇸',
      region: 'Europe',
      rationale:
        'Կոլեկտիվիզմին հակվող, շատ բարձր անորոշության խուսափում, ֆեմինինությանը հակվող, հաճույքակենտրոն',
      biases: [93, 86, 53, 55, 79, 50, 37, 22, 13, 100, 91, 20],
      confidence: 0.83,
      aliases: ['Իսպանացի', 'Spanish', 'Spaniard'],
      biasRationale: `Իսպանիան ունի շատ բարձր անորոշության խուսափում (86)՝ չափավոր կոլեկտիվիզմով (IDV 51) և բարձր հաճույքակենտրոնությամբ (44)։ Անորոշության խուսափումը ձևավորում է երկիմաստության և զրո-ռիսկի հակումներ, իսկ հաճույքակենտրոնությունը ստեղծում է հիպերբոլիկ զեղչում և դրականության էֆեկտներ։ Սոցիալական, ընտանեկենտրոն մշակույթը ստեղծում է ներխմբային ֆավորիտիզմ և զանգվածային էֆեկտներ։ Արտահայտիչ հաղորդակցության ոճը ուժեղացնում է շրջանակման էֆեկտները և անեկդոտային համոզիչությունը, իսկ հումորի էֆեկտները և ռեակտիվությունը արտացոլում են կրքոտ միջերկրածովյան բնավորությունը։`,
    },
    {
      id: 'se',
      name: 'Շվեդիա',
      flag: '🇸🇪',
      region: 'Europe',
      rationale:
        'Հավասարազոր, համաձայնության ձգտող, ցածր հաճույքակենտրոնություն, «Lagom» չափավորության մշակույթ',
      biases: [93, 70, 10, 58, 76, 97, 30, 85, 50, 17, 44, 80],
      confidence: 0.88,
      aliases: ['Շվեդ', 'Swedish'],
      biasRationale: `Շվեդիան ունի շատ բարձր անհատապաշտություն (71)՝ ծայրահեղ ցածր իշխանական հեռավորությամբ (31) և շատ ցածր մասկուլինությամբ (5)։ Չափավորության «Lagom» մշակույթը ձևավորում է սոցիալական ցանկալիություն, նորմալության հակում և բացթողման հակում համաձայնության ձգտման միջոցով։ Ցածր մասկուլինությունը ստեղծում է «ավելի քիչ — ավելի լավ» նախընտրություններ և զանգվածային համապատասխանություն խմբային նորմերին։ Առաջադիմական մշակույթը ստեղծում է նորության գրավչություն՝ պահպանելով երկիմաստության խուսափումը, իսկ ատրիբուցիայի հիմնարար սխալը արտացոլում է անհատապաշտական արժանավորության սկզբունքով հավատի համակարգը։`,
    },
    {
      id: 'ch',
      name: 'Շվեյցարիա',
      flag: '🇨🇭',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, անորոշության խուսափման բարձր մակարդակ, իշխանական չափավոր հեռավորություն, զսպված, ճշգրտությամբ առաջնորդվող',
      biases: [86, 93, 94, 87, 102, 19, 81, 83, 85, 97, 10, 49],
      confidence: 0.84,
      aliases: ['Շվեյցարացի', 'Swiss'],
      biasRationale: `Շվեյցարիան ունի անհատապաշտության բարձր մակարդակ (68)՝ նկատելի անորոշության խուսափմամբ (58) և չափավոր զսպվածությամբ (IVR 66)։ Ճշգրտությամբ առաջնորդվող մշակույթը ուժեղացնում է զրո-ռիսկի հակումը, երկիմաստության խուսափումը և տեղեկատվական հակումը։ Բանկային և ժամացույցագործության ավանդույթները ուժեղացնում են մշակման բարդության միջոցով ներգրավվածությունը և հաջորդական հիշողությունը։ Երկարաժամկետ կողմնորոշումը (74) ձևավորում է պարտավորությունների աճ և կորստի-խուսափում, իսկ համաձայնության ձգտող ուղղակի ժողովրդավարությունը ստեղծում է բացթողման հակում և «ավելի քիչ — ավելի լավ» նախընտրություններ։`,
    },
    {
      id: 'th',
      name: 'Թաիլանդ',
      flag: '🇹🇭',
      region: 'Asia',
      rationale:
        'Իշխանական մեծ հեռավորություն, կոլեկտիվիստական, անորոշության խուսափման ցածր մակարդակ, զսպված, ներդաշնակություն փնտրող',
      biases: [48, 50, 53, 70, 55, 58, 10, 22, 90, 47, 100, 13],
      confidence: 0.75,
      aliases: ['Թայ', 'Thai', 'Siam'],
      biasRationale: `Թաիլանդը ունի իշխանական մեծ հեռավորություն (64)՝ ուժեղ կոլեկտիվիզմով (IDV 20) և անորոշության խուսափման ցածր մակարդակով (64)։ Ներդաշնակություն փնտրող «kreng jai» մշակույթը ձևավորում է սոցիալական ցանկալիություն, բացթողման հակում և նորմալության հակում հակամարտությունների խուսափման միջոցով։ Իշխանական մեծ հեռավորությունը ստեղծում է ավտորիտետային հակում և համակարգի արդարացում, իսկ կոլեկտիվիզմը ստեղծում է զանգվածային էֆեկտներ և ներխմբային ֆավորիտիզմ։ Բուդդիստական ազդեցության «mai pen rai» վերաբերմունքը ստեղծում է մարող աֆեկտի հակում և դրականության էֆեկտներ։`,
    },
    {
      id: 'tr',
      name: 'Թուրքիա',
      flag: '🇹🇷',
      region: 'Middle East',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, բանակցային մշակույթ, պատվի վրա հիմնված սոցիալական կոդերով',
      biases: [48, 18, 53, 81, 22, 43, 52, 88, 47, 25, 93, 90],
      confidence: 0.82,
      aliases: ['Թուրք', 'Turkish', 'Türkiye'],
      biasRationale: `Թուրքիան ունի իշխանական մեծ հեռավորություն (66)՝ ուժեղ կոլեկտիվիզմով (IDV 37) և անորոշության խուսափման բարձր մակարդակով (85)։ Բանակցություններով հարուստ մշակույթը ուժեղացնում է խարսխման էֆեկտները և շրջանակումը, իսկ պատվի վրա հիմնված սոցիալական կոդերը ձևավորում են ներխմբային ֆավորիտիզմ և խմբային ատրիբուցիայի սխալներ։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության խուսափում և համակարգի արդարացում։ Պարտավորությունների աճը արտացոլում է մշակութային շեշտադրումը հաստատակամության և սոցիալական պարտավորությունների կատարման վրա։`,
    },
    {
      id: 'ae',
      name: 'ԱՄԷ',
      flag: '🇦🇪',
      region: 'Middle East',
      rationale:
        'Շատ բարձր իշխանական հեռավորություն, կոլեկտիվիստական, ապագայի կողմնորոշված, կարգավիճակին ուշադիր, կոսմոպոլիտ',
      biases: [48, 54, 80, 90, 53, 88, 20, 57, 79, 15, 86, 50],
      confidence: 0.74,
      aliases: ['Էմիրացի', 'UAE', 'Emirati', 'Dubai'],
      biasRationale: `ԱՄԷ-ն ունի շատ բարձր իշխանական հեռավորություն (90)՝ ուժեղ կոլեկտիվիզմով (IDV 25) և նկատելի զսպվածությամբ։ Կարգավիճակին ուշադիր կոսմոպոլիտ մշակույթը ուժեղացնում է լուսապսակի էֆեկտները, ֆոն Ռեստորֆի տարբերակումը և կոնտրաստի էֆեկտները։ Իշխանական մեծ հեռավորությունը ձևավորում է ավտորիտետային հակում և համակարգի արդարացում, իսկ ապագայի կողմնորոշված զարգացման մտածողությունը ստեղծում է նորության գրավչություն։ Մտավոր հաշվապահությունը արտահայտված է լյուքս-առևտրային մշակույթում, իսկ զրո-ռիսկի հակումը արտացոլում է պրեմիում որակի և անվտանգության շեշտադրումը։`,
    },
    {
      id: 'ua',
      name: 'Ուկրաինա',
      flag: '🇺🇦',
      region: 'Europe',
      rationale:
        'Չափավոր կոլեկտիվիզմ, անորոշության խուսափման բարձր մակարդակ, զսպված, դիմացկուն, ցածր իշխանական հեռավորություն',
      biases: [1, 83, 91, 19, 93, 17, 81, 84, 78, 10, 53],
      confidence: 0.68,
      aliases: ['Ուկրաինացի', 'Ukrainian'],
      biasRationale: `Ուկրաինան ունի չափավոր անհատապաշտություն (25)՝ բարձր անորոշության խուսափմամբ (95) և շատ ցածր հաճույքակենտրոնությամբ (18)։ Պատմական ցնցումներով ձևավորված դիմացկուն մշակույթը ուժեղացնում է մատչելիության էվրիստիկաները և բացասականության հակումը։ Անորոշության խուսափման բարձր մակարդակը ստեղծում է երկիմաստության խուսափում և պահպանողականություն, իսկ ծայրահեղ զսպվածությունը ստեղծում է բացթողման հակում։ Համայնքային ուժեղ կապերը ձևավորում են ներխմբային ֆավորիտիզմ, իսկ հնարամիտ DIY-մշակույթը ստեղծում է IKEA-ի էֆեկտներ։ Ռեակտիվությունը և ռիսկի փոխհատուցումը արտացոլում են ադապտիվ արձագանքները նեղություններին։`,
    },
    {
      id: 'gb',
      name: 'Միացյալ Թագավորություն',
      flag: '🇬🇧',
      region: 'Europe',
      rationale:
        'Անհատապաշտական, զսպված, ավանդույթներին հարգանք, չոր հումորի մշակույթ',
      biases: [20, 97, 13, 30, 71, 19, 88, 105, 12, 17, 91, 83],
      confidence: 0.89,
      aliases: ['Բրիտանացի', 'Անգլիացի', 'British', 'English', 'UK', 'Britain'],
      biasRationale: `Միացյալ Թագավորությունը ունի շատ բարձր անհատապաշտություն (89)՝ ցածր իշխանական հեռավորությամբ (35) և չափավոր հաճույքակենտրոնությամբ (69)։ Զսպված մշակույթը ձևավորում է «ավելի քիչ — ավելի լավ» և կոնտրաստի էֆեկտներ նուրբ հաղորդակցության միջոցով։ Չոր հումորը ուժեղացնում է հումորի և տարօրինակության էֆեկտները, իսկ ավանդույթներին հարգող պահպանողականությունը ստեղծում է տիրապետման և «ջայլամի» էֆեկտներ։ Բարձր անհատապաշտությունը ստեղծում է երրորդ անձի էֆեկտ և ռեակտիվություն, իսկ բացասականության հակումը արտացոլում է մշակութային ներքին թերահավատությունը և զսպվածությունը։`,
    },
    {
      id: 'us',
      name: 'ԱՄՆ',
      flag: '🇺🇸',
      region: 'Americas',
      rationale:
        'Անհատապաշտական, անորոշության խուսափման ցածր մակարդակ, մարքեթինգով հագեցած, ակնթարթային վարձատրության մշակույթ',
      biases: [77, 79, 69, 50, 80, 22, 83, 37, 71, 91, 44, 74, 78],
      confidence: 0.9,
      aliases: ['Ամերիկացի', 'American', 'USA'],
      biasRationale: `ԱՄՆ-ն ունի բացառիկ բարձր անհատապաշտություն (91) և անորոշության խուսափման ցածր մակարդակ (46), ստեղծելով մշակույթ, որը պարգևատրում է ինքնաառաջխաղացումը և ռիսկի վերցնելը։ Բարձր հաճույքակենտրոնության հետ զուգորդված (68) ամերիկացիները հատկապես զգայուն են ակնթարթային վարձատրության հակումների և սեփական դատողություններում գերվստահության նկատմամբ։ Մարքեթինգով հագեցած միջավայրը ուժեղացնում է շրջանակման էֆեկտները, զանգվածային ճնշումը և նորության գրավչությունը։`,
    },
    {
      id: 'vn',
      name: 'Վիետնամ',
      flag: '🇻🇳',
      region: 'Asia',
      rationale:
        'Կոլեկտիվիստական, իշխանական մեծ հեռավորություն, երկարաժամկետ կողմնորոշված, զսպված, ներդաշնակություն փնտրող',
      biases: [48, 50, 53, 81, 83, 70, 90, 10, 57, 19, 58, 42],
      confidence: 0.73,
      aliases: ['Վիետնամցի', 'Vietnamese'],
      biasRationale: `Վիետնամը ունի իշխանական մեծ հեռավորություն (70)՝ ուժեղ կոլեկտիվիզմով (IDV 20) և շատ բարձր երկարաժամկետ կողմնորոշմամբ (57)։ Կոնֆուցիական ազդեցության մշակույթը ձևավորում է ավտորիտետային հակում, համակարգի արդարացում և սոցիալական ցանկալիություն ներդաշնակության ձգտման միջոցով։ Երկարաժամկետ կողմնորոշումը ստեղծում է պարտավորությունների աճ, կորստի-խուսափում և մտավոր հաշվապահություն։ Կոլեկտիվիզմը ստեղծում է զանգվածային էֆեկտներ և ներխմբային ֆավորիտիզմ, իսկ զսպվածությունը (IVR 35) դրսևորվում է որպես բացթողման հակում և նորմալության հակում։`,
    },
  ],

  regions: {
    All: 'Բոլորը',
    Americas: 'Ամերիկա',
    Europe: 'Եվրոպա',
    Asia: 'Ասիա',
    'Middle East': 'Մերձավոր Արևելք',
    Africa: 'Աֆրիկա',
    Oceania: 'Օվկիանիա',
  },

  ui: {
    chooseYour: 'Ընտրիր քո',
    cyclingWords: ['Պերսոնան', 'Հակառակորդին', 'Թիրախային լսարանը', 'Մրցակցին'],
    cyclingBoldWord: 'Պերսոնան',
    subTaglineLead: 'Դուք խնդրեցիք — մենք ստեղծեցինք։ ',
    subTagline:
      'Ընտրիր երկիր՝ ինքնաբերաբար լրացնելու կոգնիտիվ հակումների պրոֆիլը։ Յուրաքանչյուր ձևանմուշ առանձնացնում է 10–15 հակում բարձր մշակութային տարածվածությամբ — պատրաստ օգտագործման Պերսոնայի կառուցողում։',
    statTemplates: 'Ազգային ձևանմուշներ',
    statReady: 'Պատրաստ ենք, երբ դու ես',
    loadingMap: 'Բեռնվում է քարտեզը…',
    tooltipBiases: 'հակում',
    tooltipHint: 'Սեղմիր՝ հակումների պրոֆիլը տեսնելու համար',
    searchPlaceholder: 'Փնտրիր երկիր կամ ազգություն...',
    moreCountries: (n: number) => `+${n} ևս երկիր`,
    showLess: 'Ցույց տալ ավելի քիչ',
    matchSuffix: '% համապատասխանություն',
    whyTheseBiases: 'Ինչո՞ւ այս հակումները',
    whyApproxNote:
      'Սա մոտավոր գնահատական է, որն արտացոլում է, թե որքանով է հակումների ձևանմուշը համապատասխանում այս երկրի համար փաստաթղթավորված վարքագծային օրինաչափություններին։',
    hofstedeNote:
      'Հիմնված է Հոֆստեդեի մշակութային չափումների և վարքագծային հետազոտությունների ընդգրկման վրա։',
    useInPersonaBuilder: 'Լրացնել պերսոնան {country}',
    emptyStateLead: 'Ընտրիր երկիրը և ',
    emptyStateLink: 'տես քո բիզնեսի ապագան',
    emptyStateHint: 'Սեղմիր՝ հակումների ձևանմուշը բեռնելու համար',
    footerBiases: 'հակում',
    footerConfidence: 'վստահություն',
  },
};
